import useSWR from "swr";
import axios from "axios";

const fetcher = async (url) => {
  const data = await axios.get(url);
  return data.data;
};

export default function FetcherTest() {
  const { data, error } = useSWR(
    "https://api.github.com/repos/vercel/swr",
    fetcher
  );

  if (error)
    return <div style={{ margin: "50px" }}>An error has occurred.</div>;
  if (!data) return <div style={{ margin: "50px" }}>Carregandio...</div>;
  return (
    <div style={{ margin: "50px" }}>
      <h1>{data.name}</h1>
      <p>{data.description}</p>
      <strong>👁 {data.subscribers_count}</strong>{" "}
      <strong>✨ {data.stargazers_count}</strong>{" "}
      <strong>🍴 {data.forks_count}</strong>
    </div>
  );
}
